module.exports = __webpack_public_path__ + "img/391204816_707772634540111_5545185312369130738_n.d206aa04.jpeg";